import * as React from 'react'
import styled from '@emotion/styled'
import { transparentize } from 'polished'
import { Link } from 'gatsby'
import AppBar from '@material-ui/core/AppBar'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import MenuIcon from '@material-ui/icons/Menu'
import IconButton from '@material-ui/core/IconButton'
import { Hidden, Button, Icon } from '@material-ui/core'
import css from '@emotion/css'
import { Location } from '@reach/router'
import InstagramIcon from '@material-ui/icons/Instagram'
import TwitterIcon from '@material-ui/icons/Twitter'
import { heights, dimensions, colors, fonts, breakpoints } from '../styles/variables'
import Container from './Container'
import Logo from './Logo'
import { getEmSize } from '../styles/mixins'

interface HeaderProps {
  title: string
  backgroundColor: string
}

const StyledHeader = styled(AppBar)<{ backgroundColor: string }>`
  height: ${heights.header}px;
  padding: 0 50px;
  background-color: ${props => props.backgroundColor};
  color: ${transparentize(0.5, colors.darkBlue)};
  box-shadow: none;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    padding: 0;
  }
`

const HeaderInner = styled(Container)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 18px;
  height: 100%;
  width: 100%;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    padding-top: 30;
    justify-content: space-around;
    width: 100%;
  }
`

const HomepageLink = styled(Link)`
  color: ${colors.darkBlue};
  font-size: 2rem;
  height: 80%;

  &:hover,
  &:focus {
    text-decoration: none;
  }
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    width: 100px;
  }
`

const HeaderLinks = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
`

const HeaderLink = styled(Link)`
  margin-left: 15px;
  color: ${colors.darkBlue};
  font-size: 1.2rem;
  font-weight: 400;
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
  &:hover,
  &:focus {
    text-decoration: none;
    color: ${colors.darkerBlue};
    font-weight: 900;
  }
`

const DrawerLink = styled(Link)`
  /* color: ${colors}; */
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`

const DrawerInner = styled(Container)`
  padding: 50px;
  display: flex;
  height: 100%;
  flex-flow: column;
  background-color: ${colors.darkBlue};
`

const HeaderDonateButton = styled(Button)`
  background-color: ${colors.red};
  color: ${colors.white};
  font-weight: 800;
  letter-spacing: 0.1em;
  font-size: 20px;
  font-family: ${fonts.sansSerif};
  padding-left: 20px;
  padding-right: 20px;
  margin-left: 30px;
  border-radius: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  &:hover,
  &:focus {
    background-color: ${colors.darkRed};
    color: ${colors.white};
  }
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    background-color: transparent;
    margin: 0;
    padding: 0;
    span {
      font-size: 20px;
      color: ${colors.red};
      background-color: transparent;
    }
    &:hover,
    &:focus {
      background-color: transparent;
      color: ${colors.white};
      font-weight: 900;
    }
  }
`

const DrawerDonateButton = styled(Button)`
  background-color: ${colors.red};
  color: ${colors.white};
  font-weight: 800;
  font-size: 20px;
  font-family: ${fonts.sansSerif};
  letter-spacing: 0.1em;
  margin-bottom: 15px;
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  &:hover,
  &:focus {
    background-color: ${colors.red};
    color: ${colors.white};
  }
`

const StyledSwipeableDrawer = styled(SwipeableDrawer)``

const Header: React.FC<HeaderProps> = ({ title, backgroundColor }) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false)

  return (
    <StyledHeader position="absolute" backgroundColor={backgroundColor}>
      <HeaderInner>
        <Hidden smDown>
          <HomepageLink style={{ fontFamily: fonts.title }} to="/">
            <Logo
              css={css`
                width: 216px;
                @media (max-width: ${getEmSize(breakpoints.lg)}em) {
                  width: 100px;
                }
              `}
            />
          </HomepageLink>
          <HeaderLinks>
            <IconButton href="https://twitter.com/brotherjones_">
              <TwitterIcon />
            </IconButton>
            {/* <IconButton href="https://twitter.com/brotherjones_">
              <InstagramIcon />
            </IconButton> */}
            <HeaderLink to="/">Home</HeaderLink>
            <HeaderLink to="/issues">Issues</HeaderLink>
            <HeaderLink to="/about">About</HeaderLink>
            {/* <HeaderLink to="/volunteer">Volunteer</HeaderLink> */}
            {/* <HeaderLink to="/events">Events</HeaderLink> */}
            {/* <HeaderLink to="/press">Press</HeaderLink> */}
            <HeaderDonateButton href="https://secure.actblue.com/donate/justin-jones-for-congress-1">CONTRIBUTE</HeaderDonateButton>
          </HeaderLinks>
        </Hidden>
        <Hidden mdUp>
          <IconButton onClick={() => setDrawerOpen(true)}>
            <MenuIcon
              css={css`
                color: ${colors.darkBlue};
              `}
            />
          </IconButton>
          <StyledSwipeableDrawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)} onOpen={() => setDrawerOpen(true)}>
            <DrawerInner>
              <div
                css={css`
                  display: flex;
                  margin-bottom: 20px;
                `}
              >
                <IconButton
                  href="https://twitter.com/brotherjones_"
                  css={css`
                    color: ${colors.white};
                  `}
                >
                  <TwitterIcon />
                </IconButton>
                {/* <IconButton href="https://twitter.com/brotherjones_">
                  <InstagramIcon
                    css={css`
                      color: ${colors.white};
                    `}
                  />
                </IconButton> */}
              </div>
              <DrawerLink to="/">Home</DrawerLink>
              <DrawerLink to="/issues">Issues</DrawerLink>
              <DrawerLink to="/about">About</DrawerLink>
              {/* <DrawerLink to="/volunteer">Volunteer</DrawerLink> */}
              {/* <DrawerLink to="/events">Events</DrawerLink> */}
              {/* <DrawerLink to="/press">Press</DrawerLink> */}
              <DrawerDonateButton href="https://secure.actblue.com/donate/justin-jones-for-congress-1">CONTRIBUTE</DrawerDonateButton>
            </DrawerInner>
          </StyledSwipeableDrawer>
          <HomepageLink style={{ fontFamily: fonts.title }} to="/">
            <Logo />
          </HomepageLink>
          <HeaderDonateButton href="https://secure.actblue.com/donate/justin-jones-for-congress-1">DONATE</HeaderDonateButton>
        </Hidden>
      </HeaderInner>
    </StyledHeader>
  )
}

export default Header
